import { render, staticRenderFns } from "./vsProgress.vue?vue&type=template&id=70bdc3ff&lang=html"
import script from "./vsProgress.vue?vue&type=script&lang=js"
export * from "./vsProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports